import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { mergeCallbacks, useListSelection, useListStyle, useUniqueId, } from '@clds/compound-components';
import { Item } from '@clds/item';
import { useRegisterChildData } from './childData.js';
// https://github.com/microsoft/TypeScript/issues/47663
export const ID_ATTRIBUTE_NAME = 'data-selectable-id';
export const useMenuItemProps = ({ onClick, id: idProvided, ...rest }) => {
    const listStyle = useListStyle();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const id = useUniqueId(idProvided);
    const childData = useMemo(() => ({ onClick }), [onClick]);
    useRegisterChildData(id, childData);
    const { onClick: onClickListSelection, ...selection } = useListSelection(id);
    const onClickCombined = mergeCallbacks(onClickListSelection, onClick);
    // TODO currently we don't want to show menu items focused and selected at the same time
    // this is because after clicking the menu it receives both focused and selected and you expect just the normal state
    // we should find the way to indicate focused&selected only after the keyboard interaction
    const shouldFocusedBeIndicated = selection.isFocused && selection.isSelected ? false : selection.isFocused;
    return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        [ID_ATTRIBUTE_NAME]: id,
        ...listStyle,
        ...selection,
        isFocused: shouldFocusedBeIndicated,
        onClick: onClickCombined,
        ...rest,
    };
};
export const MenuItem = ({ children, ...rest }) => {
    const listItemProps = useMenuItemProps(rest);
    return _jsx(Item, { ...listItemProps, children: children });
};
